import { useUser } from "@components/user-context";

export const useIsAccountOwnerOrAdmin = () => {
  const { user } = useUser();
  return user.authedUserId === user.displayUserId || user.isAdmin;
};
